<template>
  <v-container fluid>
    <template>
      <v-carousel v-if="$vuetify.breakpoint.mdAndUp" class="carousell" :show-arrows="false">
        <v-carousel-item v-for="(post, i) in wild.slice(0,7)" :key="i" :src="post.mediaUrl" contain></v-carousel-item>
      </v-carousel>
      <v-gallery :images="imageList" />
    </template>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "WildlifeContent",
  computed: {
    ...mapState(["loadingWild", "wild"]),
    imageList() {
      let list = [];
      //let count = 0;
      this.wild.forEach(element => {
        list.push({ title: element.id, url: element.mediaUrl });
        //count++;
      });
      return list;
    },
  },
  mounted() {
    if (!this.wild.length) this.$store.dispatch("cargarWild");
  }
};
</script>

<style scoped>
/deep/.url {
  text-decoration-line: none;
  color: #b80b0b !important;
  font-style: italic;
}

.title {
  text-align: justify;
  font-size: 3.2vmin !important;
  text-decoration-line: underline;
  word-break: break-word;
}

.subtitle {
  text-align: start;
  font-size: 2.2vmin !important;
  word-break: break-word;
}

/deep/.v-window__container {
  margin-top: -48px !important;
}

.text {
  text-align: justify;
  padding-right: 1rem;
  padding-left: 1rem;
  font-size: 2.4vmin !important;
  word-break: break-word;
  margin-bottom: 0;
}

.carousell {
  margin-bottom: 24px;
  max-width: 35%;
}

.cols {
  padding-top: 0;
}

.v-carousel {
  width: 60vw !important;
  margin: auto;
}

@media only screen and (max-width: 1264px) {
  .carousell {
    margin-bottom: 24px;
    max-width: 75%;
  }
}
</style>